import {observer} from 'mobx-react';
import * as React from 'react';
import {Component} from 'react';
import {autobind} from "core-decorators";
import {WordMasksController} from "./WordMasks";
import {observable} from "mobx";
import {checkQuota} from "../../utils/infinitives";
import {GetQuotaCheckDocument, GetQuotaCheckQuery, GetQuotaCheckQueryVariables} from "../../types.d";
import {Field} from "@intelingu/core/components/form/Field";
import {TextInput} from "./form/elements/TextInput";
import {HiddenField} from "./form/elements/HiddenField";
import {graphql} from "../../configs/graphql.client";
import {ApolloClient} from "apollo-client";

interface QuotaCheckFieldProps {
    onChange?;
    onCheckResult?;
    sourceLanguage: number;
    translationLanguage: number;
    includedWords: string[];
    explanationQuotaFieldName: string;
    explanationCounterFieldName: string;
    wordMasksController: WordMasksController;
    getInfinitives: () => string;
    escalateMode?: boolean;
    originalMode?: boolean;
    isStatic?: boolean;
    client?: ApolloClient<any>;
}

@observer export class QuotaCheckField extends Component<QuotaCheckFieldProps, any> {

    @observable value = '';
    @observable content = '';

    @observable isValid = true;
    @observable isCounterValid = true;

    @autobind async checkQuota(content) {
        const {
            wordMasksController,
            includedWords,
            sourceLanguage,
            translationLanguage,
        } = this.props;

        try {
            const result = checkQuota({
                content,
                wordMasksController,
                includedWords,
            });

            wordMasksController.highlightedWords = [];
            for (const word of wordMasksController.allWords) {
                if (word.rank <= 10 && result.tokens.indexOf(word.word.toLowerCase()) > -1) {
                    wordMasksController.highlightedWords.push(word.id);
                }
            }

            const client: ApolloClient<any> = (this.props.client || graphql.client);
            const checkResult = await client.query<GetQuotaCheckQuery, GetQuotaCheckQueryVariables>({
                query: GetQuotaCheckDocument,
                variables: {
                    sourceLanguage,
                    translationLanguage,
                    values: result.tokens,
                    excludedWords: includedWords.map(word => word.toLowerCase()),
                },
            });

            if (this.props.onCheckResult) {
                this.props.onCheckResult(checkResult.data.quotaCheck);
            }

            this.value = checkResult.data.quotaCheck.content;
            this.content = checkResult.data.quotaCheck.quotaData;

            this.isCounterValid = !wordMasksController.allWords.length || wordMasksController.highlightedWords.length > 0;
            this.isValid = checkResult.data.quotaCheck.valid;

            if (!this.props.isStatic) {
                this.props.onChange(result.result);
            }
        } catch (e) {
            console.log(e);
        }
    }

    @autobind checkQuotaForFieldValue() {
        this.checkQuota(this.props.getInfinitives());
    }

    componentDidMount(): void {
        if (this.props.isStatic) {
            this.checkQuotaForFieldValue();
        }
    }

    render() {
        const { explanationCounterFieldName, explanationQuotaFieldName, isStatic, escalateMode, originalMode } = this.props;

        return <>
            <div className={'infinitives-container'}>
                { isStatic ? (
                    originalMode ? (
                        <code className="infinitives" contentEditable={false} dangerouslySetInnerHTML={{
                            __html: this.value
                        }} />
                    ) : (
                        <div dangerouslySetInnerHTML={{ __html: this.value }} />
                    )
                ) : (
                    <>
                        <button
                            type="button"
                            onClick={this.checkQuotaForFieldValue}
                            className="btn btn-primary">Fill infinitives and Check quota</button>

                        <code className="infinitives" contentEditable={true} dangerouslySetInnerHTML={{
                            __html: this.value
                        }} />
                    </>
                ) }

                { this.content && this.content.length && (
                    <div className={'quota-data-status'} dangerouslySetInnerHTML={{ __html: this.content }} />
                )}
            </div>

            { (!isStatic && !escalateMode) && (
                <>
                    <Field
                        name={explanationQuotaFieldName + 'Valid'}
                        render={props => <HiddenField data={this.isValid} {...props} />} />

                    <Field
                        name={explanationCounterFieldName + 'Valid'}
                        render={props => <HiddenField data={this.isCounterValid} {...props} />} />
                </>
            ) }

            { (!this.isValid && !isStatic && !escalateMode) && (
                <div className={`mt-3 ${!this.isCounterValid ? 'mb-3' : ''}`}>
                    <label>Please explain your decision... <i className={'required'} /></label>
                    <Field name={explanationQuotaFieldName} render={props => (
                        <TextInput {...props} />
                    )} />
                </div>
            )}

            { (!this.isCounterValid) && (
                <>
                    <div className="quota-data-status mb-2">
                        <div className="quota-bad">{ !isStatic ? 'please use' : 'no' } words with counter 10 or less</div>
                    </div>

                    { (!isStatic && !escalateMode) && (
                        <div className={'mt-3'}>
                            <label>Please explain your decision... <i className={'required'} /></label>
                            <Field name={explanationCounterFieldName} render={props => (
                                <TextInput {...props} />
                            )} />
                        </div>
                    ) }
                </>
            )}
        </>
    }

}
